import { usersClient } from "../generated/users";
var currentUserPromise;
/*
 * Lazily fetches the user and caches the response so callers may use this
 * method any time they need, worry-free.
 *
 * Intended to replace the old Current variable in Kaggle.Web.
 */ export var getCurrentUser = function() {
    if (!currentUserPromise) {
        currentUserPromise = usersClient.usersService.getCurrentUser({
            includeGroups: false
        });
    }
    return currentUserPromise;
};
/**
 * Pause an async function for a set amount of time.
 */ export function delay(milliseconds) {
    return new Promise(function delayResolver(resolve) {
        window.setTimeout(resolve, milliseconds);
    });
}
